"use client";

import { Check, Copy } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { writeToClipboard } from "@/lib/clipboard";
import { EMBED_COPY } from "@/lib/embed-copy";

export function SnippetField({
  id,
  label,
  value,
  rows = 6,
}: {
  id: string;
  label: string;
  value: string;
  rows?: number;
}) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    if (await writeToClipboard(value)) {
      setCopied(true);
      window.setTimeout(() => {
        setCopied(false);
      }, 2000);
      return;
    }
    toast.error(EMBED_COPY.studio.copyFailed);
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between gap-3">
        <Label htmlFor={id}>{label}</Label>
        <Button
          className="gap-1.5"
          onClick={handleCopy}
          size="sm"
          type="button"
          variant="outline"
        >
          {copied ? (
            <Check className="size-3.5" />
          ) : (
            <Copy className="size-3.5" />
          )}
          {copied ? EMBED_COPY.studio.copied : EMBED_COPY.studio.copyHtml}
        </Button>
      </div>
      <textarea
        className="min-h-24 w-full resize-y rounded-lg border border-input bg-muted/30 px-3 py-2 font-mono text-xs leading-relaxed outline-none focus:border-ring focus:ring-2 focus:ring-ring/20"
        id={id}
        readOnly
        rows={rows}
        spellCheck={false}
        value={value}
      />
    </div>
  );
}
